import { InjectionToken } from '@angular/core';

export const FORGERY_API_BASE_URL = new InjectionToken<string>(
  'FORGERY_API_BASE_URL',
  { providedIn: 'root', factory: () => 'https://ipzxtewhadwa018.azurewebsites.net' }
);

export const ACCEPTED_EXTENSIONS = ['pdf', 'jpg', 'jpeg', 'png', 'tiff', 'tif', 'bmp', 'webp'];
export const MAX_FILES = 45;
export const MAX_TOTAL_BYTES = 50 * 1024 * 1024;
